import { Col, Form, Input, Row, Select, Table } from 'antd';
import { Content } from 'antd/es/layout/layout';
import { EyeIcon, FilterGoldIcon, FilterIcon } from 'assets/svg';
import { MainLayout } from 'components';
import Button from 'components/Button';
import useQueryParam from 'hooks/useQueryPrams';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import pageTitleStore from 'store/pageTitleStore';
import { DEFAULT_PAGE_SIZE } from 'utils/constants';
import { ColumnsType } from 'antd/es/table';

type FixedType = 'left' | 'right' | boolean;

export default function StoreInfo() {
  const history = useHistory();
  const queryParam = useQueryParam();

  const [isOpenFilter, setIsOpenFilter] = useState<boolean>(false);

  const setTitle = pageTitleStore((state) => state.setTitle);
  const setBreadcrumb = pageTitleStore((state) => state.setBreadcrumb);
  useEffect(() => {
    setTitle('Thông tin cửa hàng');
    setBreadcrumb([
      {
        title: (
          <p>
            <a href="">Thông tin đơn vị</a>
          </p>
        ),
      },
      {
        title: <a href="/store-info">Thông tin cửa hàng</a>,
      },
    ]);
  }, []);

  const page = parseInt(queryParam.get('page') + '') || 1;
  const page_size =
    parseInt(queryParam.get('page_size') + '') || DEFAULT_PAGE_SIZE;

  const toggleFilter = () => {
    setIsOpenFilter(!isOpenFilter);
  };

  const columns: ColumnsType<any> = [
    {
      title: 'STT',
      dataIndex: 'id',
      width: 60,
      render: (text, record, index) => index + 1 + page_size * (page - 1),
    },
    {
      title: 'Khu vực',
      //   dataIndex: 'name',
      width: 100,
    },
    {
      title: 'Mã chi nhánh',
      //   dataIndex: 'name',
      width: 130,
    },
    {
      title: 'Tên chi nhánh',
      //   dataIndex: 'name',
      width: 130,
    },
    {
      title: 'Tổng vốn chi nhánh',
      //   dataIndex: 'name',
      width: 180,
    },
    {
      title: 'Tổng vốn phân bổ min cửa hàng',
      //   dataIndex: 'name',
      width: 280,
    },
    {
      title: 'Tổng vốn phê duyệt min',
      //   dataIndex: 'name',
      width: 200,
    },
    {
      title: 'Tổng vốn phê duyệt max',
      //   dataIndex: 'name',
      width: 200,
    },
    {
      title: 'Trạng thái',
      //   dataIndex: 'name',
      width: 100,
    },
    {
      title: 'Trạng thái phân bổ',
      //   dataIndex: 'name',
      width: 190,
    },
    {
      title: 'CH được phân bổ',
      //   dataIndex: 'name',
      width: 150,
    },
    {
      title: 'Người tạo',
      //   dataIndex: 'name',
      width: 160,
    },
    {
      fixed: 'right' as FixedType,
      width: 120,
      align: 'center',
      render: (_: any, record: any) => (
        <div className="flex justify-around">
          <button>
            <EyeIcon />
          </button>
        </div>
      ),
    },
  ];

  return (
    <MainLayout>
      <Row justify="end" gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
        <Col>
          <Button
            bgColor={'bg-white'}
            color={`${isOpenFilter ? 'text-primary-50' : 'text-secondary-50'}`}
            border={`${
              isOpenFilter ? 'border-primary-50' : 'border-secondary-50'
            }`}
            onClick={toggleFilter}
          >
            {isOpenFilter ? <FilterIcon /> : <FilterGoldIcon />}
            Lọc
          </Button>
        </Col>
      </Row>

      <Form
        // form={form}
        layout="vertical"
        className={`items-center ${isOpenFilter ? '' : 'hidden'} mt-4`}
        // onFinish={onFinish}
        autoComplete="off"
      >
        <Content>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="" span={8}>
              <Form.Item name="" label="Mã cửa hàng">
                <Select placeholder="Chọn mã cửa hàng" defaultValue="Tất cả">
                  {/* {lstPofType?.data?.map((item) => (
                    <Option value={item.pof_type_code} key={item.id}>
                      {item.pof_type_name}
                    </Option>
                  ))} */}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item name="" label="Tên cửa hàng">
                <Input placeholder="Nhập tên cửa hàng" />
              </Form.Item>
            </Col>
            <Col className="" span={8}>
              <Form.Item name="" label="Khu vực">
                <Select placeholder="Chọn loại giỏ hàng" defaultValue="Tất cả">
                  {/* {lstPofType?.data?.map((item) => (
                    <Option value={item.pof_type_code} key={item.id}>
                      {item.pof_type_name}
                    </Option>
                  ))} */}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row justify="end" gutter={{ xs: 4, sm: 8, md: 16, lg: 24 }}>
            <Col>
              <Button
                bgColor={'bg-white'}
                color={'text-primary-50'}
                border={'border-primary-50'}
              >
                Huỷ
              </Button>
            </Col>
            <Col>
              <Button>Tìm kiếm</Button>
            </Col>
          </Row>
        </Content>
      </Form>

      <Content>
        <Table
          rowKey={(record) => record.id}
          columns={columns}
          className="customTable"
          //   dataSource={cartAllocated?.data}
          scroll={{ x: 958 }}
          //   loading={getCartsLoading}
        />
      </Content>
    </MainLayout>
  );
}
